import TeacherMarkingSummary from './TeacherMarkingSummary';

export default TeacherMarkingSummary;
